<template>
  <main-layout>
    <div class="wrap">
      <div class="middle container">
        <div class="survey"><a href="http://manabang.mikecrm.com/ogYbOBW" target="_blank">我们想更了解您的想学习/感兴趣的方向，点击参与调研>></a></div>
        <div class="offlineCourse">
          <h3 class="academyTitle">
            {{$t('global.付费课程')}}
          </h3>
          <ul class="list">
            <li v-for="item in offlineCourseList">
              <a class="offline-course-card" :href="item.url" target="_blank;">
                <div class="left">
                  <span class="status status-collecting" v-if="item.status == 1"></span>
                  <span class="status status-opening" v-if="item.status == 2"></span>
                  <span class="status status-closed" v-if="item.status == 4"></span>
                  <span class="status status-expired" v-if="item.status == 3"></span>
                  <img :src="item.image | imageUrl('',270,360)" />
                </div>
                <div class="right">
                  <h5>{{item.title}}</h5>
                  <p class="user">
                    <img v-if="item.userAvatar" :src="item.userAvatar | imageUrl('/static/profile_img_default.png',60,60)" />
                    {{item.username}}
                  </p>
                  <p class="tag-wrap">
                    <span class="tag" v-for="tag in item.tags">{{tag}}</span>
                  </p>
                  <p class="info">
                    <span class="price"
                      :class="{'price-disabled':(item.status < 3 && (item.amount - item.saleAmount) == 0) ||
                        item.status == 3 ||
                        new Date() > new Date(item.endTime)}"
                        v-if="item.price"
                    >￥<b>{{item.price}}</b></span>
                    <span class="amount" v-if="item.saleAmount > 0">{{item.saleAmount}}{{$t('global.人已购买')}}</span>
                  </p>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout";

export default {
  name: "AcademyOfflineCourse",
  metaInfo() {
    return {
      title: "MANA" + this.$t("global.学院") + "-" + this.$t("global.付费课程")
    };
  },
  components: {
    MainLayout
  },
  data() {
    return {
      offlineCourseList: [],
      isLogin: localStorage.getItem("auth_token") !== null
    };
  },
  created() {
    this.getOfflineCourseList();
  },
  methods: {
    getOfflineCourseList() {
      var urlReplace = function(str) {
        return str.replace(/&amp;/g, '&');
      };
      this.$http
        .get("/api/common/page", {
          params: {
            id: 3315
          }
        })
        .then(res => {
          if (res.code === "OK") {
            const arr = res.data.body.match(/<code>(.*)<\/code>/);
            if (arr.length === 2) {
              const data = arr[1]
                .replace(/"/g, "`")
                .replace(/&quot;/g, '"')
                .replace(/<[^a][^((?!\/a).)*][^>]*>/g, "");
              this.offlineCourseList = JSON.parse(data);
              this.offlineCourseList.map(function(item) {
                item.url = urlReplace(item.url);

                var now = new Date(),
                  endTime = new Date(item.endTime.trim().replace(/\s+/g,"T")),
                  stock = item.amount - item.saleAmount;

                if(now > endTime) {
                  item.status = 3; //已结束
                } else if(stock == 0) {
                  item.status = 4; //已满员
                }
              });
            }
          }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.wrap {
  padding-top: 20px;
  background: #fff;
}

.survey {
  padding: 10px;
  background: rgba(54,100,237,0.1);
  text-align: center;

  a {
    font-size: 14px;
    font-weight: bold;
    color: #3664ED;
  }
}

.academyTitle {
  padding: 40px 0 20px;
  font-size: 24px;

  .more {
    float: right;
    color: #999;
    font-size: 12px;
    font-weight: normal;
    line-height: 33px;
  }
}
.top {
  padding-top: 0.6rem;
}

.offlineCourse {
  .list {
    overflow: hidden;

    li {
      float: left;
      width: 563px;
      margin: 0 30px 30px 0;
      border: 1px solid rgba(224,224,224,1);

      &:nth-child(2n) {
        margin-right: 0;
      }

      .offline-course-card {
        display: block;
        height: 180px;
        position: relative;
        padding: 20px 20px 20px 175px;
        background: #fff;

        .left {
          position: absolute;
          top: 20px;
          left: 20px;
          width: 135px;
          height: 180px;

          img {
            width: 135px;
            height: 180px;
            border-radius: 4px;
          }

          .status {
            position: absolute;
            top: 4px;
            left: -9px;
            width: 72px;
            height: 35px;
            background-size: 100%;
          }

          .status-collecting {
            background-image: url("/static/contest_collecting_tag@3x.png");
          }

          .status-opening {
            width: 60px;
            background-image: url("/static/college_opening_tag@3x.png");
          }

          .status-closed {
            width: 60px;
            background-image: url("/static/college_closed_tag@3x.png");
          }

          .status-expired {
            width: 60px;
            background-image: url("/static/college_expired_tag@3x.png");
          }
        }

        .right {
          position: relative;
          height: 180px;

          h5 {
            height: 60px;
            font-size: 20px;
            line-height: 30px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            color: #333;
          }

          .user {
            margin-top: 6px;
            color: #999;
            font-size: 12px;

            img {
              display: inline;
              width: 20px;
              height: 20px;
              margin-right: 5px;
              border-radius: 100%;
              vertical-align: middle;
              border: 1px solid #eee;
            }
          }

          .tag-wrap {
            height: 22px;
            margin-top: 4px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

            .tag {
              display: inline-block;
              margin-right: 5px;
              padding: 0 4px;
              color: #3664ED;
              font-size: 12px;
              line-height: 20px;
              background: rgba(54,100,237, 0.1);
              border-radius: 3px;
            }
          }

          .info {
            position: absolute;
            right: 0;
            bottom: 0;
            left: 0;
            color: #999;
            font-size: 12px;
            line-height: 16px;

            .price {
              color: #FC6240;

              b {
                font-size: 24px;
              }
            }

            .price-disabled {
              color: #ccc;
            }

            .amount{
              float: right;
            }
          }

          .btn-wrap {
            position: absolute;
            right: 0;
            bottom: 0;
            text-align: right;

            .btn {
              display: inline-block;
              width: 90px;
              height: 34px;
              background: #3664ED;
              color: #fff;
              font-size: 16px;
              font-weight: bold;
              text-align: center;
              line-height: 34px;
              border-radius: 20px;
            }

            .btn-disable {
              background: #eee;
              color: #999;
            }
          }
        }
      }
    }
  }
}


.top-filter {
  color: #000;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  border-radius: 8px;
  overflow: hidden;
  zoom: 1;
  background: #fff;
}
.top-tabs {
  width: 140px;
  float: left;
  font-size: 0.26rem;
}
.top-tab {
  height: 0.87rem;
  line-height: 0.87rem;
  text-align: center;
  background-color: #fbfbfb;
  cursor: pointer;
  color: #999;
}
.top-tab.active {
  background-color: #fff;
  color: #333333;
}
.top-tab-contents {
  width: 1020px;
  float: left;
}
.filter-result {
  margin-top: 0.2rem;
  text-align: center;
}
.filter-result .pre {
  margin-right: 0.4rem;
}
.filter-result .el-button {
  color: #0060ff;
  border-color: #dcdfe6 !important;
}
.filter-result .el-button-group {
  margin-right: 0.2rem;
}
.orderby {
  margin: 0 0 20px;
  line-height: 0.16rem;
  color: #777777;
  font-size: 0.16rem;
}
.orderby .add {
  float: right;
  color: #0060ff;
}
.orderby > label {
  display: inline-block;
  margin-right: 0.3rem;
}
.orderby .active {
  color: #0060ff;
}
.orderby label {
  cursor: pointer;
}
.orderby-icon-time {
  display: inline-block;
  width: 0.16rem;
  height: 0.16rem;
  background: url("/static/explore/time.png") no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
}
.orderby-icon-visit {
  display: inline-block;
  width: 0.19rem;
  height: 0.16rem;
  background: url("/static/explore/visit.png") no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
  margin-left: 0.35rem;
}
.orderby-icon-zan {
  display: inline-block;
  width: 0.16rem;
  height: 0.16rem;
  background: url("/static/explore/zan.png") no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
  margin-left: 0.35rem;
}
.orderby-icon-comment {
  display: inline-block;
  width: 0.16rem;
  height: 0.16rem;
  background: url("/static/explore/comment.png") no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
  margin-left: 0.35rem;
}
.vedio-list .el-row {
  margin: 0 -0.13rem;
}
.vedio-list .item {
  margin: 0.13rem;
  cursor: pointer;
}
.author-item {
  overflow: hidden;
  zoom: 1;
  border-bottom: 1px solid #dddddd;
  padding: 0.4rem 0;
}
.author-info {
  float: left;
  width: 7.46rem;
  overflow: hidden;
  zoom: 1;
}
.author-avatar {
  width: 1.3rem;
  height: 1.3rem;
  float: left;
  display: block;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
}
.author-content {
  width: 6.13rem;
  float: left;
  padding-left: 0.3rem;
  padding-top: 0.07rem;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.author-name {
  font-size: 0.26rem;
  color: #333333;
}
.author-title {
  font-size: 0.16rem;
  color: #777777;
  margin: 0.1rem 0 0.2rem;
}
.author-focus {
  display: block;
  width: 1.2rem;
  height: 0.4rem;
  line-height: 0.4rem;
  padding: 0;
  font-size: 0.16rem;
  color: #fff;
  text-align: center;
  background-color: #0060ff;
  -webkit-border-radius: 0.2rem;
  -moz-border-radius: 0.2rem;
  border-radius: 0.2rem;
}
.author-vedio {
  float: right;
  width: 8.6rem;
  margin: 0.07rem -0.05rem 0;
  overflow: hidden;
  zoom: 1;
  position: relative;
}
.author-vedio-item {
  width: 25%;
  float: left;
  padding: 0 0.05rem;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.author-vedio-item img {
  width: 2.06rem;
  height: 1.16rem;
  display: block;
  margin: 0 auto;
}
.orderby-icon-user {
  display: inline-block;
  width: 0.16rem;
  height: 0.17rem;
  background: url("/static/explore/user.png") no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
}
.orderby-icon-vedio {
  display: inline-block;
  width: 0.16rem;
  height: 0.17rem;
  background: url("/static/explore/vediocount.png") no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
  font-size: 0.26rem;
}
.orderby .active-time {
  background: url("/static/explore/focusTime.png") no-repeat center center;
  background-size: contain;
}
.orderby .active-user {
  background: url("/static/explore/focusUser.png") no-repeat center center;
  background-size: contain;
}
.orderby .active-video {
  background: url("/static/explore/focusVideo.png") no-repeat center center;
  background-size: contain;
}
.subject-list {
  margin: 0 auto;
  overflow: hidden;
  zoom: 1;
}
.subject-item {
  cursor: pointer;
  display: block;
  float: left;
  width: 565px;
  margin: 0 30px 30px 0;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  background-color: #fff;
  overflow: hidden;
  position: relative;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-shadow: 2px 2px 2px #eaeaea;
  -moz-box-shadow: 2px 2px 2px #eaeaea;
  box-shadow: 2px 2px 2px #eaeaea;
}

.subject-item:nth-child(2n) {
  margin-right: 0;
}
.subject-add {
  cursor: pointer;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
  font-size: 0.22rem;
  color: #333333;
  padding: 0;
}
.subject-add:before {
  content: "";
  display: block;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  width: 7.8rem;
  height: 100px;
  position: absolute;
  left: 0.1rem;
  top: 0.1rem;
  border: 2px dotted #e1e1e1;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
}
.subject-add:after {
  content: "";
  display: block;
  width: 0.8rem;
  height: 0.8rem;
  background: url("/static/explore/add.png") no-repeat center center;
  background-size: contain;
  position: absolute;
  left: 1.5rem;
  top: 1.5rem;
}
.subject-img {
  display: block;
  height: 161px;
  width: 565px;
}
.subject-content {
  padding: 20px;
}
.subject-title {
  font-size: 20px;
  color: #333;
  font-weight: bold;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.subject-summary {
  height: 40px;
  margin-top: 10px;
  font-size: 14px;
  color: #999;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  word-break: break-word;
}
.subject-count {
  margin-top: 15px;
  font-size: 12px;
  color: #999;
}
.subject-count span {
  margin-right: 10px;
}
.subject-count span i {
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/pages/academy/offlineCourseList.vue